import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import { Personnel } from './personnel';
import PersonnelDeleteModal from './personnel-delete-modal';
import PersonnelDetail from './personnel-detail';
import PersonnelUpdate from './personnel-update';
import AbsencesProfesseur from './professeur-absences';
import CoursProfesseur from './professeur-cours';
import PersonnelOtpModal from './personnel-otp-modal';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/new`} component={PersonnelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/edit`} component={PersonnelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/details`} component={PersonnelDetail} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/verify-otp`} component={PersonnelOtpModal} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/cours`} component={CoursProfesseur} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/absences`} component={AbsencesProfesseur} />

      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/delete`} component={PersonnelDeleteModal} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid`} component={Personnel} />
    </Switch>
  </>
);

export default Routes;
